<script setup lang="ts">
import { useSearch } from "~/composables/search";
import SelectTag from "~/components/form/SelectTag.vue";
import { DATATYPES } from "~/constants/dataTypes";

// Data
const { dataType, search, limit, result, loading, error, doFetch, pagination } = useSearch();
dataType.value = "character"; // router.currentRoute.value.path.split("/")[1].toLowerCase();

const { title, description } = DATATYPES[dataType.value];

await doFetch();
</script>

<template>
  <div>
    <div class="mb-4 md:mb-10">
      <h1 class="text-3xl capitalize leading-loose md:inline-block">{{ title }}</h1>

      <p class="mb-10 font-light text-grc-gray-darker md:pl-1">
        {{ description }}
      </p>
    </div>

    <div>
      <div class="flex-row-reverse items-end md:flex">
        <SearchBox v-model="search" class="mb-2 flex-none md:ml-2 md:w-1/3" />

        <div class="flex-1 pb-2 text-right">
          <!-- Per page -->
          <SelectTag v-model="limit" class="w-full md:w-auto">
            <option v-for="val in ['10', '20', '50', '100']" :key="val" :value="val">View {{ val }} per page</option>
          </SelectTag>
        </div>

        <div class="mt-4 flex-1 md:mt-0">More specific types:</div>
      </div>

      <!-- List items -->
      <ListItems :items="result" :apply-row-link="false">
        <template #header>
          <div class="flex-none lg:w-[50px]">Char</div>

          <div class="flex-none lg:w-[90px]">Unicode</div>

          <div class="flex-none lg:w-[50px]">Dec</div>

          <div class="flex-none lg:w-[50px]">Hex</div>

          <div class="flex-none lg:w-[70px]">Binary</div>

          <div class="flex-none lg:w-[60px]">HTML</div>

          <div class="flex-1">Description</div>
        </template>

        <template #row="{ item }">
          <div class="flex-none lg:w-[50px]">{{ item.fieldData.grapheme }}</div>

          <div class="flex-none lg:w-[90px]">{{ item.fieldData.unicode }}</div>

          <div class="flex-none lg:w-[50px]">{{ item.fieldData.decimal }}</div>

          <div class="flex-none lg:w-[50px]">{{ item.fieldData.hex }}</div>

          <div class="flex-none lg:w-[70px]">{{ item.fieldData.binary }}</div>

          <div class="flex-none lg:w-[60px]">{{ item.fieldData.html }}</div>

          <div class="flex-1">{{ item.fieldData.definition }}</div>
        </template>
      </ListItems>

      <!-- Pagination content -->
      <div v-if="pagination" class="mt-4 md:flex">
        <div class="mb-2 flex-1 text-center md:mb-0 md:text-left">
          Showing <b>{{ pagination.showItemStart }}</b>

          to <b>{{ pagination.showItemEnd }}</b>

          of <b>{{ pagination.totalItems }}</b> results
        </div>

        <PaginationLinks :data="pagination" class="flex-1 text-center md:text-right" />
      </div>
    </div>
  </div>
</template>
